<div class="w-full flex flex-col text-center">
  <div class="w-full" [ngStyle]="{'height': showLegend ? '50vh' : '35vh'}" echarts [options]="chartOption"></div>
  <h2 class="text-2xl">{{getTitle()}}</h2>
  <h2 class="text-xl italic mt-1">{{getSubtitle()}}</h2>
  <h3 *ngIf="isSampleData" class="text-lg italic mt-1">(Sample Data)</h3>
</div>
